import VueRouter from 'vue-router'
import routes from './routes'
import i18n from '../i18n/i18n'

export default new VueRouter({
    mode: 'history',
    routes
})

export function getName(enName) {
    let parent = false
    let selectedRoute = routes.find(route => {
        parent = route.name == enName
        return route.children
            ? route.name == enName
                ? true
                : route.children.map(i => i.name).includes(enName)
            : route.name == enName
    })
    return selectedRoute.children
        ? parent
            ? selectedRoute.langName[i18n.locale]
            : selectedRoute.children.find(route => route.name == enName).langName[i18n.locale]
        : selectedRoute.langName[i18n.locale]
}
export function getPath(enName) {
    let temp =routes.map(route => {
    return route.name == enName ?
        route.path : 
        (route.children ? 
            (route.children.map(i => i.name).includes(enName) ?
                route.path + route.children.find(route => route.name == enName).path : 
                null)
            : null)
    })
    return (temp?.filter(c=>c != null).toString()) 
}